// Brands allowed to be created
export const ALLOWEDBRANDS = ['BGT', 'CON', 'GDY', 'HKK', 'MCL', 'PRL', 'YKH']
